import { useFormContext, useWatch } from 'react-hook-form';

import { DatePickerTime } from 'shared_DEPRECATED/components/Form/DatePicker';
import { dateUtils } from 'shared_DEPRECATED/utils';

import { getDateStringWithUpdatedTime } from 'features/sessions/utils';

import { Typography } from 'shared/components/Typography';

export const SessionsFormActualEndTimeSelector = () => {
  const { setValue } = useFormContext();
  const [sessionStartedAtDate, sessionEndDate] = useWatch({
    name: ['startedAt', 'endedAt'],
  });

  const localStartedDate = dateUtils.localDate(sessionStartedAtDate).toDate();

  const filterSessionEndDateTime = (endDate: Date) =>
    dateUtils(endDate).isAfter(
      dateUtils.localDate(localStartedDate).toISOString()
    );

  const onTimeChange = (date: Date) => {
    const updatedEndDate = getDateStringWithUpdatedTime(sessionEndDate, date);

    setValue('endedAt', updatedEndDate, {
      shouldDirty: true,
    });

    const isSelectedDateBeforeStartDate =
      dateUtils(updatedEndDate).isSameOrBefore(localStartedDate);

    if (isSelectedDateBeforeStartDate) {
      const sessionStartedAtDate = dateUtils(updatedEndDate)
        .subtract(15, 'minute')
        .toISOString();

      setValue('startedAt', sessionStartedAtDate);
    }
  };

  return (
    <Typography as="div" type="meta" dataTestid="session-end-time">
      <DatePickerTime
        date={dateUtils.localDate(sessionEndDate || undefined).toDate()}
        onChange={onTimeChange}
        filterTime={filterSessionEndDateTime}
      />
    </Typography>
  );
};
